export const setValuesForCheckout = (list) => {
    return {
        type: 'SET_VALUES_CHECKOUT',
        payload: list
    }
};
